export const grundbuchgeschaeftSearchModeName = 'searchMode';
